import 'css-chunksrc/client/pages/capacityPage/table/row/cell/numberInput/styles.scss';export default {
  "numberInput": "_numberInput_1i4l4_1",
  "main": "_main_1i4l4_9",
  "arrows": "_arrows_1i4l4_17",
  "input": "_input_1i4l4_21",
  "icon": "_icon_1i4l4_50",
  "iconBox": "_iconBox_1i4l4_54",
  "disabled": "_disabled_1i4l4_75"
};